export default {
  remote: 'simplify_hub_admin_portal_mfe',
  name: 'admin-portal',
  source: 'https://github.com/telus/cloud-coe-simplify-backstage-plugins',
  urlMapping: {
    localhost: 'https://assets.wcpreview.telus.com/642608889/ccoe-admin-portal-mfe/v1/mf2/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcpreview.telus.com/642608889/ccoe-admin-portal/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/642608889/ccoe-admin-portal/v1/mf2/mf-manifest.json',
    'simplify.telus.com':
      'https://assets.telus.com/642608889/ccoe-admin-portal/v1/mf2/mf-manifest.json',
  },
};
